import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import HotsheetForm from './Form'

@inject('websites', 'hotsheets')
@observer
export default class AddHotsheet extends Component {
  website = this.props.websites.current

  handleData = data => {
    return this.props.hotsheets.create(data).then(newHotsheet => {
      this.props.router.push({
        pathname: `/website/${this.website.id}/hotsheets`,
        state: { highlight: newHotsheet.id }
      })
    })
  }

  getDefaults() {
    const { state={}, query } = this.props.location
    return { ...state, ...query }
  }

  render() {
    return (
      <div className="container centered padded hotsheets">
        <HotsheetForm
          defaults={this.getDefaults()}
          submit="Create Hotsheet"
          router={this.props.router}
          onData={this.handleData} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Hotsheets/Add.js